<script setup>
import Button from '@components/global/button.vue'

defineProps(['item'])
</script>
<template>
	<Button class="card flex flex-col gap-6" simple :to="{ name: 'merch-item', params: { slug: item.slug } }">
		<div class="relative flex h-[320px] items-center justify-center overflow-hidden rounded-2xl bg-bgSecondary p-12">
			<img :src="item.image" class="animation aspect-square w-[250px] object-contain scale-100" :alt="item.title" />
			<div v-if="item.discount" class="absolute right-3 top-3 rounded-full bg-bgMain px-3 py-2 font-extrabold uppercase">
				{{ item.discount }}
			</div>
		</div>
		<div class="flex flex-col gap-1 font-semibold text-base">
			<span class="text-sm text-primaryLight">{{ item.type }}</span>
			<span>{{ item.title }}</span>
			<div class="mt-3 flex gap-2">
				<span v-if="item.compare_at_price" class="text-secondaryHard line-through">
					{{ item.compare_at_price }}
				</span>
				<span class="font-bold">{{ item.price }}</span>
			</div>
		</div>
	</Button>
</template>
<style scoped>
.card:hover img {
	@apply scale-105;
}

.btn {
	@apply max-h-full flex-col md:items-start gap-6;
}
</style>
